<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import estoqueService from '@/src/services/api-receituario/estoque'
import produtoService from '@/src/services/produto_estoque'
import moment from 'moment'
moment.locale('pt-br')
/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading },
  data() {
    return {
      filterDataInicial: '',
      filterDataFinal: '',
      filterProduto: '',
      mostraForm: true,
      estoqueEdit: {},
      produtos: [],
      estoques: [],
      historicos: [],
      estoqueSelect: [],
      estoquesExcel: [],
      columns: [
        {
          label: 'cliente',
          field: 'cliente',
        },
        {
          label: 'produto',
          field: 'produto',
        },
        {
          label: 'quantidade',
          field: 'quantidade',
        },        
        {
          label: 'nota',
          field: 'nota',
        },
        {
          label: 'receita',
          field: 'receita',
        },
        {
          label: 'data',
          field: 'data',
        },
        {
          label: 'tipo',
          field: 'tipo',
        },
      ],
      estoqueFields: [
        {
          key: 'cliente',
          label: 'Cliente',
          class: 'size-col-20',
        },
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'quantidade',
          label: 'Qtde.',
          class: 'size-col-20',
        },   
        {
          key: 'n_nf',
          label: 'Nº Nota Fiscal',
          class: 'size-col-20',
        },
        {
          key: 'n_receita',
          label: 'Nº Receituário',
          class: 'size-col-20',
        },            
        {
          key: 'data',
          label: 'Data da Movimentação',
          class: 'size-col-20',
        },
        {
          key: 'tipo_movimento',
          label: 'Tipo Movimentação',
          class: 'size-col-20',
        },
        
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      historicoFields: [
        {
          key: 'produto.nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'quantidade',
          label: 'Quantidade Movimentada',
          class: 'size-col-20',
        },
        {
          key: 'disponivel',
          label: 'Estoque disponível',
          class: 'size-col-20',
        },
        {
          key: 'minimo',
          label: 'Estoque mínimo',
          class: 'size-col-20',
        },
        {
          key: 'maximo',
          label: 'Estoque máximo',
          class: 'size-col-20',
        },
        {
          key: 'tipo_movimento',
          label: 'Tipo da Movimentação',
          class: 'size-col-20',
        },
        {
          key: 'data',
          label: 'Data da Movimentação',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      tipoMovimentos: [
        {
          tipo_movimento: 'E',
          descricao: 'Entrada',
        },
        {
          tipo_movimento: 'S',
          descricao: 'Saída',
        },
      ],
      currentPage: 1,
      perPage: 500,
      showModal: false,
      isLoading: false,
      filter: '',
      rows: 0,
    }
  },
  computed: {},

  watch: {
    mostraForm() {
      if (this.mostraForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
    this.handleGetProduto()
  },
  methods: {
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService
        .listar(token)
        .then((resposta) => {
          this.estoques = resposta.data.estoques
          this.isLoading = false
          this.estoqueExcel = this.estoques.map(function (element) {
           
            return {
              cliente: element.cliente == undefined ? '--' : element.cliente,
              produto: element.nome == undefined ? '--' : element.nome,
              quantidade: element.quantidade == undefined ? '--' : element.quantidade,
              nota: element.n_nf == undefined ? '--' : element.n_nf,
              receita: element.n_receita == undefined ? '--' : element.n_receita,
              data: element.data == undefined ? '--' : element.data,
              tipo: element.tipo_movimento == undefined ? '--' : element.tipo_movimento === 'E' ? 'Entrada' : 'Saída',
            }
          })
           
          console.log(this.estoqueExcel);
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.unidadeEdit = {}
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listando()
      }
    },
    atualizar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      console.log(this.estoqueEdit)
      estoqueService
        .update(token, this.estoqueEdit)
        .then((resposta) => {
          this.$bvModal.hide('modal-editar-movimentacao')
          this.isLoading = false
          if (!resposta.data.sucesso) {
            this.$bvToast.toast(resposta.data.mensagem, {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          } else {
            this.$bvToast.toast('Estoque atualizado!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          }
          this.estoqueEdit = {}
          this.findByDate()
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(
            erro.response ? erro.response.data.data : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService
        .salvar(token, this.estoqueEdit)
        .then((resposta) => {
          this.$bvModal.hide('modal-movimentacao')
          this.isLoading = false
          if (!resposta.data.sucesso) {
            this.$bvToast.toast(resposta.data.mensagem, {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          } else {
            this.$bvToast.toast('Estoque atualizado!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          }
          this.estoqueEdit = {}
          this.listando()
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(
            erro.response ? erro.response.data.data : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
    removeMovimentacao() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService.deletar(token, this.estoqueEdit.id).then((response) => {
        this.produtos = response.data.produtos
        this.isLoading = false
        this.$bvModal.hide('modal-remove-movimentacao')
        this.$bvModal.hide('modal-historico')
        this.listando()
      })
    },
    handleGetProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      produtoService.listar(token).then((response) => {
        this.produtos = response.data.produtos
        this.isLoading = false
      })
    },

    showHistoryByProduct(id) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService.findAllByProduct(token, id).then((response) => {
        this.historicos = response.data.estoques
        this.isLoading = false
        this.$bvModal.show('modal-historico')
      })
    },
    showRemoveStockProduct(estoque) {
      this.estoqueEdit = estoque
      this.$bvModal.show('modal-remove-movimentacao')
    },
    showEditStockProduct(estoque) {
      this.estoqueEdit = {}
      this.estoqueEdit = estoque
      this.$bvModal.show('modal-editar-movimentacao')
    },
    showModalNewStock() {
      this.estoqueEdit = {}
      this.$bvModal.show('modal-movimentacao')
    },
    findByDate() {
      if (
        this.filterDataInicial != undefined ||
        this.filterDataFinal != undefined ||
        this.filterProduto != undefined ||
        this.filterReceituario != undefined ||
        this.filterNota != undefined
      ) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true
        estoqueService
          .findAllByDate(token, this.filterDataInicial, this.filterDataFinal, this.filterProduto, this.filterReceituario, this.filterNota)
          .then((resposta) => {
            this.estoques = resposta.data.estoques
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
            this.$bvToast.toast(
              error.response ? error.response.data.message : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.estoques = []
            this.rows = 1
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Movimentação de estoque</div>
            <div class="subTitulo">Visualize o estoque da sua empresa aqui.</div>
          </div>
          <div class="col-md-2">
            <div class="float-right">
              <button class="btn btn-primary" @click="showModalNewStock()">
                <span v-if="mostraForm">Nova movimentação</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="row" v-if="mostraForm">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <b-form-group id="input-group-1" label="Data inicial" label-for="input-2">
                <b-form-datepicker id="datepicker-inicial" v-model="filterDataInicial"
                  placeholder="Selecione a data inicial" :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }" locale="pt-br">
                  <template v-slot:button-content>
                    <b-icon icon="calendar" variant="primary"></b-icon>
                  </template>
                </b-form-datepicker>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group id="input-group-1" label="Data final" label-for="input-2">
                <b-form-datepicker id="datepicker-final" v-model="filterDataFinal" placeholder="Selecione a data final"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }" locale="pt-br">
                  <template v-slot:button-content>
                    <b-icon icon="calendar" variant="primary"></b-icon>
                  </template>
                </b-form-datepicker>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-1" label="Produto" label-for="input-2">
                <b-form-input type="text" v-model="filterProduto" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-1" label="Nº Receituário" label-for="input-2">
                <b-form-input type="text" v-model="filterReceituario" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group id="input-group-1" label="Nº Nota" label-for="input-2">
                <b-form-input type="text" v-model="filterNota" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2 mt-1">
              <button class="btn btn-primary mt-4 mt-1" @click="findByDate">Pesquisar</button>
            </div>
          </div>

        </div>
      </div>

      <div v-if="mostraForm">
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="float-right">
              <button class="btn btn-primary" @click="$refs.btnexport.$el.click()">
                Exportar Excel
                <vue-excel-xlsx ref="btnexport" style="display: none" :data="estoqueExcel" :columns="columns"
                  :filename="'estoques'" :sheetname="'estoques'">
                </vue-excel-xlsx>
              </button>
            </div>
          </div>
        </div>
        <b-table striped hover responsive="sm" borderless bordered outlined small :items="estoques"
          :fields="estoqueFields" :filter="filter" show-empty>
          <template #empty="scope">
            <div class="row">
              <div class="col-md-12">
                <span>Nenhum estoque encontrado!</span>
              </div>
            </div>
          </template>
          <template v-slot:cell(data)="row">
            {{
              formatDate(row.item.data) !== 'Invalid date'
              ? formatDate(row.item.data)
              : row.item.data
            }}
          </template>
          <template v-slot:cell(tipo_movimento)="row">
              <span v-if="row.item.tipo_movimento === 'E'" variant="primary" class="pl-2 pr-2 pt-1 pb-1">ENTRADA</span>
              <span v-else-if="row.item.tipo_movimento === 'S'" variant="info" class="pl-2 pr-2 pt-1 pb-1">SAÍDA</span>
            </template>
          <template v-slot:cell(actions)="row">
            <div class="btn-group">
              <button v-b-tooltip.hover title="Editar" type="button" class="btn btn-light"
                @click="showEditStockProduct(row.item)">
                <i class="uil uil-edit"></i>
              </button>
              <button v-b-tooltip.hover title="Histórico" type="button" class="btn btn-light"
                @click="showHistoryByProduct(row.item.id_produto)">
                <i class="uil uil-search"></i>
              </button>
            </div>
          </template>
          <template v-slot:cell(ativo)="row">{{
            row.item.ativo ? 'Sim' : 'Não'
          }}</template>
        </b-table>
      </div>

      <div v-else>
        <b-form>
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col">
                  <b-form-group label="Descrição">
                    <b-form-input v-model="unidadeEdit.unid1" />
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col"> </div>
            </div>
          </div>
          <b-button type="submit" variant="primary" @click.prevent="salvar">Salvar</b-button>
        </b-form>
      </div>
    </div>

    <b-modal id="modal-remove-movimentacao" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja remover essa movimentação de estoque?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-remove-movimentacao')">Não</b-button>
        <b-button variant="danger" @click="removeMovimentacao">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-editar-movimentacao" title="Editar Estoque" title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Tipo de Movimentação" label-for="input-1">
            <v-select class="style-select" :options="tipoMovimentos" :reduce="(item) => item.tipo_movimento"
              label="descricao" v-model="estoqueEdit.tipo_movimento">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Produto" label-for="input-1">
            <v-select class="style-select" :options="produtos" :reduce="(item) => item.id_produto" label="nome"
              v-model="estoqueEdit.id_produto">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Data de entrada" label-for="input-2">
            <b-form-datepicker id="datepicker-inicial" v-model="estoqueEdit.data" placeholder="Selecione a data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-br">
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>

        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Quantidade" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Quantidade" v-model="estoqueEdit.disponivel"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="Estoque Minimo" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Estoque Minimo" v-model="estoqueEdit.minimo"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="Estoque Máximo" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Estoque Máximo" v-model="estoqueEdit.maximo"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Quantidade Embalagens" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Quantidade Embalagens" v-model="estoqueEdit.quantidade"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="NF" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Número da NF" v-model="estoqueEdit.n_nf"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="Nº Receituário" label-for="input-1">
            <b-form-input id="input-1" type="text" placeholder="Número do Receituário" v-model="estoqueEdit.n_receita"
              required></b-form-input>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-editar-movimentacao')">Cancelar</b-button>
        <b-button variant="primary" @click="atualizar">Salvar</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-movimentacao" title="Movimentação de Estoque" title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Tipo de Movimentação" label-for="input-1">
            <v-select class="style-select" :options="tipoMovimentos" :reduce="(item) => item.tipo_movimento"
              label="descricao" v-model="estoqueEdit.tipo_movimento">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Produto" label-for="input-1">
            <v-select class="style-select" :options="produtos" :reduce="(item) => item.id_produto" label="nome"
              v-model="estoqueEdit.id_produto">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Data de entrada" label-for="input-2">
            <b-form-datepicker id="datepicker-inicial" v-model="estoqueEdit.data" menu-class="w-100" calendar-width="100%"
              class="mb-2" placeholder="Selecione a data" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-br" @input="get_data()">
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>

        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Quantidade" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Quantidade" v-model="estoqueEdit.disponivel"
              required></b-form-input>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-movimentacao')">Cancelar</b-button>
        <b-button variant="primary" @click="salvar">Salvar</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-historico" title="Histórico por Produto" title-class="font-18" size="xl">
      <div class="row">
        <div class="col-md-12">
          <b-table striped hover responsive="sm" borderless bordered outlined small :items="historicos"
            :fields="historicoFields" show-empty>
            <template #empty="scope">
              <div class="row">
                <div class="col-md-12">
                  <span>Nenhum estoque encontrado!</span>
                </div>
              </div>
            </template>
            <template v-slot:cell(actions)="row">
              <button v-b-tooltip.hover title="Excluir" type="button" class="btn btn-light"
                @click="showRemoveStockProduct(row.item)">
                <i class="uil uil-trash-alt"></i>
              </button>
            </template>
            <template v-slot:cell(data)="row">
              {{
                formatDate(row.item.data) !== 'Invalid date'
                ? formatDate(row.item.data)
                : row.item.data
              }}
            </template>
            <template v-slot:cell(tipo_movimento)="row">
              <span v-if="row.item.tipo_movimento === 'E'" variant="primary" class="pl-2 pr-2 pt-1 pb-1">ENTRADA</span>
              <span v-else-if="row.item.tipo_movimento === 'S'" variant="info" class="pl-2 pr-2 pt-1 pb-1">SAÍDA</span>
            </template>
          </b-table>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('modal-historico')">Fechar</b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>